<script setup lang="ts">
defineProps<{ message: string; id: string }>();
const { $t } = useNuxtApp();
const site = useSiteStore();
</script>
<template>
  <span :id="id" class="text-sm text-error-500 ml-1">
    {{ $t(`${message}-${site.getRegionCode}`, message) }}
  </span>
</template>
